import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useParams, useNavigate } from "react-router-dom";
import styles from "../../../layout/admin/Main.module.scss";
//専用コンポーネント
import ApplicantCourseDataTable from "./ApplicantCourseDataTable";
import SearchForm from "./CourseSearchForm";
//共通コンポーネント
import ScreenTitle from "../../../layout/admin/ScreenTitle";
import SubScreenTitle from "../../../layout/admin/SubScreenTitle";
import Form from "../../../ui/Form";
import Button from "../../../ui/Button";
import CSVDownloader from "../../../ui/CSVDownloader";
import Loading from "../../../../components/ui/Loading";
import Progress from "../../../../components/ui/Progress";
import DetailTable from "../../../../components/ui/AdminDetailTable";
//API
import { getCodeMasterList } from "../../../../services/apiCodeMaster";
import {
  GetStudentDetail,
  GetApplicantCourseList,
  postUpdateApplicantCourse,
} from "../../../../services/apiStudent";
import { getCsvJson } from "../../../../utils/csvJson";
//定数
import { OLD_SITE_ID, SITE_ID } from "../../../../utils/config";

const displayTypeStudent = 1; //画面モード_学生詳細
const displayTypeCourse = 2; //画面モード_申込講座

const approvalStatusApporoval = 1; //承認ステータス_承認済み

const controled = "1"; //公開ステータス・公開（formデータと比較のため文字列）
const disControld = "0"; //公開ステータス・公開

const csvItems = {
  course_name: "講座名",
  lottery_status_text: "当選状況",
  univ_id: "大学ID",
  id: "申込者ID",
  how_apply_text: "申込方法",
  attendance_status_text: "未受講・受講中・受講済み",
  attendance_updated_date_str: "出欠情報更新日時",
  acquisition_unit: "取得単位数",
  attendance1_text: "1回目",
  attendance2_text: "2回目",
  attendance3_text: "3回目",
  attendance4_text: "4回目",
  attendance5_text: "5回目",
  attendance6_text: "6回目",
  attendance7_text: "7回目",
  attendance8_text: "8回目",
  attendance9_text: "9回目",
  attendance10_text: "10回目",
  attendance11_text: "11回目",
  attendance12_text: "12回目",
  attendance13_text: "13回目",
  attendance14_text: "14回目",
  attendance15_text: "15回目",
};

const StudentDetail = () => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();
  //画面モード
  const [displaytype, changeDisplayType] = useState(displayTypeStudent);
  //ユーザーID
  const { userId } = useParams();
  const [studentId, setStudentId] = useState(displayTypeStudent);
  /*学生詳細データ*/
  //表示学生データ
  const [studentInfoElements, SetStudentInfoElements] = useState([]);
  /*申込講座データ*/
  // 検索条件
  const [searchCondition, setSearchCondition] = useState({});
  //区分ドロップダウン
  const [attendance, setAttendance] = useState([]); //出席
  // 一覧データ
  const [tableData, setTableData] = useState([]);
  // 表示ページ
  const [currentPage, setCurrentPage] = useState(1);
  // CSVダウンロードデータ
  const [csvData, setCsvData] = useState({});
  // ローディング表示
  const [loading, setLoading] = useState(false);

  //初回レンダリング
  useEffect(() => {
    //ドロップダウンリストを取得
    (async function () {
      const data = await getCodeMasterList({ code: "CD006" });
      if (!data) return;
      setAttendance(
        data.map((d) => {
          return { label: d.d_text, value: d.d_value };
        }),
      );
    })();

    (async function () {
      //学生情報をセット
      const st_data = await GetStudentDetail(userId, false);
      //存在しない学生のユーザーID・または承認されていないユーザーのIDの場合、エラー
      if (
        Object.keys(st_data).length === 0 ||
        st_data?.approval_status !== approvalStatusApporoval
      ) {
        navigate("/admin/404");
        return;
      }
      setStudentId(st_data.student_id);

      const address =
        st_data.pref +
        st_data.street_name1 +
        st_data.street_name2 +
        st_data.address +
        st_data.street_name3;
      SetStudentInfoElements([
        { label: "学生番号(8桁)", value: st_data.login_id },
        { label: "期生ID(入学年月)", value: st_data.generation_id },
        {
          label: "氏名",
          value: st_data.is_wheelchair
            ? "【車いす】" + st_data.name
            : st_data.name,
        },
        { label: "フリガナ", value: st_data.name_kana },
        { label: "郵便番号", value: st_data.postcode },
        { label: "住所", value: address },
        { label: "生年月日", value: st_data.birthday_str },
        { label: "性別", value: st_data.gender },
        { label: "電話番号1", value: st_data.phone_1 },
        { label: "メールアドレス1", value: st_data.mail_1 },
        { label: "電話番号2", value: st_data.phone_2 },
        { label: "メールアドレス2", value: st_data.mail_2 },
        { label: "緊急連絡先(氏名)", value: st_data.emergency_name },
        { label: "緊急連絡先(続柄)", value: st_data.emergency_emereletion },
        { label: "緊急連絡先(電話番号)", value: st_data.emergency_phone },
        { label: "提出日", value: st_data.filing_date_str },
        { label: "総単位数", value: st_data.total_units },
        {
          label: "メール配信",
          value: st_data.is_email === true ? "配信する" : "配信しない",
        },
        {
          label: "ログイン拒否",
          value: st_data.is_rejection === true ? "ログイン不可" : "ログイン可",
        },
        { label: "学生番号発行年月日", value: st_data.date_issue_num_str },
        {
          label: "在校生・卒業生",
          value: st_data.is_graduation === true ? "卒業生" : "在校生",
        },
        { label: "学生区分", value: st_data.student_type_text },
      ]);
    })();
  }, []); // ,初回レンダリング

  //申込講座検索
  useEffect(() => {
    // 申込者一覧画面でない場合はなにもせずにreturn
    if (displaytype !== displayTypeCourse) return;

    const mapTableDataFunc = (d) => {
      return {
        key: d.id,
        name_link: (
          <Link
            to={"../../course/detail/applicant/" + d.course_id + "/" + userId}
          >
            {
              //TODO リンクで「戻る」をした場合の挙動確認
            }
            {d.course_name}
          </Link>
        ),
        student_id: d.student_id,
        course_id: d.course_id,
        course_name: d.course_name,
        updated_at: d.updated_at,
        lottery_status: d.lottery_status_text,
        univ_id: d.univ_id,
        id: d.id,
        how_apply: d.how_apply_text,
        attendance_status: d.attendance_status_text,
        attendance_updated_date: d.attendance_updated_date_str,
        acquisition_unit: d.acquisition_unit,
        attendance1: d.attendance1,
        attendance2: d.attendance2,
        attendance3: d.attendance3,
        attendance4: d.attendance4,
        attendance5: d.attendance5,
        attendance6: d.attendance6,
        attendance7: d.attendance7,
        attendance8: d.attendance8,
        attendance9: d.attendance9,
        attendance10: d.attendance10,
        attendance11: d.attendance11,
        attendance12: d.attendance12,
        attendance13: d.attendance13,
        attendance14: d.attendance14,
        attendance15: d.attendance15,
      };
    };
    const mapCsvDataFunc = (d) => {
      return getCsvJson(csvItems, d);
    };

    //申込講座検索
    (async function () {
      setLoading(true);
      setCurrentPage(1);
      if (searchCondition.control === controled) {
        //公開
        const data = await GetApplicantCourseList(userId, searchCondition);
        //テーブルデータに追加
        setTableData(data.data_list.map(mapTableDataFunc));
        setCsvData(data.data_list.map(mapCsvDataFunc));
      } else if (searchCondition.control === disControld) {
        //非公開
        let newTableData = [];
        let newCsvData = [];
        let siteIds = [OLD_SITE_ID, SITE_ID];
        for (let index = 0; index < siteIds.length; index++) {
          for (let i = 0; i < 1000; i++) {
            const data = await GetApplicantCourseList(
              userId,
              searchCondition,
              i,
              siteIds[index],
            );
            if (data.is_end || !data.data_list) {
              // 検索条件に関わらず1件もAPIからデータが取得できなくなった場合
              break;
            }
            //テーブルデータに追加
            newTableData = [
              ...newTableData,
              ...data.data_list.map(mapTableDataFunc),
            ];
            newCsvData = [
              ...newTableData,
              ...data.data_list.map(mapCsvDataFunc),
            ];
          }
        }
        setTableData(newTableData);
        setCsvData(newCsvData);
      }
      setLoading(false);
    })();
    // 初期値をとってくる
  }, [searchCondition]); //申込講座検索

  //画面切り替え時の処理
  useEffect(() => {
    //画面切り替え時に検索結果をリセットする
    if (displaytype === displayTypeCourse) {
      setSearchCondition({}); //全件取得
    }
  }, [displaytype]); //画面切り替え時の処理

  // 一括更新
  async function onSubmit(data) {
    // 一括更新処理
    const json = await postUpdateApplicantCourse(userId, data);
    if (json) {
      alert("更新完了");
      // 申込者一覧画面を再描画
      const nurl = new URL(window.location.href);
      window.location.href = nurl.origin + "/admin/student/detail/" + userId;
    }
  }

  return (
    <div className={styles.main}>
      <ScreenTitle>学生管理</ScreenTitle>
      <SubScreenTitle>学生詳細</SubScreenTitle>
      <div className={styles.buttonbox__tab}>
        <Button
          type="button"
          styleType={displaytype === displayTypeStudent ? "tab_active" : "tab"}
          onClick={() => changeDisplayType(displayTypeStudent)}
        >
          学生詳細
        </Button>
        <Button
          type="button"
          styleType={displaytype === displayTypeCourse ? "tab_active" : "tab"}
          onClick={() => changeDisplayType(displayTypeCourse)}
        >
          申込済み講座
        </Button>
      </div>

      {displaytype === displayTypeStudent ? (
        //学生詳細タブ
        <>
          <div className={styles.buttonbox__left}>
            <Link to={"/admin/student/detail/update/" + userId}>
              <Button type="button" styleType="search">
                情報変更
              </Button>
            </Link>
          </div>
          <DetailTable elements={studentInfoElements}></DetailTable>
          <div className={styles.buttonbox__left}>
            <Link to={"/admin/student/detail/update/" + userId}>
              <Button type="button" styleType="search">
                情報変更
              </Button>
            </Link>
          </div>
        </>
      ) : (
        <></>
      )}
      {displaytype === displayTypeCourse ? (
        //申込講座詳細タブ
        <>
          <SubScreenTitle>講座検索</SubScreenTitle>
          <SearchForm setSearchCondition={setSearchCondition}></SearchForm>
          <Form onSubmitHandler={handleSubmit(onSubmit)}>
            <div hidden>
              <input
                type="text"
                name="student_id"
                value={studentId}
                {...register("student_id", {})}
              ></input>
            </div>
            <ApplicantCourseDataTable
              attendance={attendance}
              tableData={tableData}
              register={register}
              setValue={setValue}
              errors={errors}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
            <div className={styles.buttonbox__left}>
              <Button type="submit" styleType="new">
                更新
              </Button>
            </div>
          </Form>
          <div className={styles.buttonbox__left}>
            <CSVDownloader
              data={csvData}
              filenameprefix="申込済み講座一覧"
              buttonname="ダウンロード"
            />
          </div>
          {loading ? <Loading /> : <></>}
          {loading ? <Progress /> : <></>}
        </>
      ) : (
        <></>
      )}
      <div className={styles.buttonbox}>
        <Link className={styles.link} to="/admin/student">
          学生管理へ戻る
        </Link>
      </div>
      <div className={styles.buttonbox}>
        <Link className={styles.link} to="/admin/top">
          トップページへ戻る
        </Link>
      </div>
    </div>
  );
};
export default StudentDetail;
